import _ from 'lodash'
import { JSONEditor } from '@json-editor/json-editor'
import { Validator } from '@json-editor/json-editor/src/validator.js'
import { extend } from '@json-editor/json-editor/src/utilities.js'

const BaseEditor = JSONEditor.defaults.editors.multiple

class MultipleEditor extends BaseEditor {
  setValue (val, initial) {
    _.each(this.validators, (validator, i) => {
      const object = _.get(this.types[i], 'options.select_via_property')
      if (object) {
        if (_.get(val, object.property) === object.value) {
          this.type = i
          this.switcher.value = this.display_text[i]
          return false
        }
      } else if (!validator.validate(val).length) {
        this.type = i
        this.switcher.value = this.display_text[i]
        return false
      }
    })
  
    this.switchEditor(this.type)
    this.editors[this.type].setValue(val, initial)
    this.refreshValue()
    this.onChange()
  }

  build () {
    const { container } = this

    // ************ //
    // Learning Labs Changes Start
    // ************ //
    if (this.schema.labelOverride) {
      this.label = this.theme.getFormInputLabel(this.schema.labelOverride, this.isRequired())
      this.label.style.display = 'block'
      this.container.appendChild(this.label)
    }
    // ************ //
    // Learning Labs Changes End
    // ************ //

    this.header = this.label = this.theme.getFormInputLabel(this.getTitle(), this.isRequired())
    this.container.appendChild(this.header)

    this.switcher = this.theme.getSwitcher(this.display_text)
    container.appendChild(this.switcher)
    this.switcher.addEventListener('change', e => {
      e.preventDefault()
      e.stopPropagation()

      this.switchEditor(this.display_text.indexOf(e.currentTarget.value))
      this.onChange(true)
    })

    this.editor_holder = document.createElement('div')
    container.appendChild(this.editor_holder)

    const validatorOptions = {}
    if (this.jsoneditor.options.custom_validators) {
      validatorOptions.custom_validators = this.jsoneditor.options.custom_validators
    }

    this.switcher_options = this.theme.getSwitcherOptions(this.switcher)
    this.types.forEach((type, i) => {
      this.editors[i] = false

      let schema

      if (typeof type === 'string') {
        schema = extend({}, this.schema)
        schema.type = type
      } else {
        schema = extend({}, this.schema, type)

        /* If we need to merge `required` arrays */
        if (type.required && Array.isArray(type.required) && this.schema.required && Array.isArray(this.schema.required)) {
          schema.required = this.schema.required.concat(type.required)
        }
      }
      this.validators[i] = new Validator(this.jsoneditor, schema, validatorOptions, this.defaults)
    })

    this.switchEditor(0)
  }

  buildChildEditor (i) {
    super.buildChildEditor(i)

    if (this.editors[i].container) {
      this.editors[i].container.classList.add('je-one-of-child')
    }

    if (this.editors[i].header) {
      this.editors[i].header.style.display = ''
    }
  }

  getWatchedFieldValues () {
    const mTitle = this.display_text?.[this.type] || this.getTitle()
    return { ...super.getWatchedFieldValues(), mTitle }
  }

  showValidationErrors (errors) {
    if (this.defaults.options.show_errors !== 'never') {
      super.showValidationErrors(errors)
    }
  }
}

export default MultipleEditor
